export default __webpack_public_path__ + "static/media/CV_EN.f7fb2ef7.pdf";